export function Container({ as, className, children }) {
  let Component = as ?? "div";

  return (
    <Component className={`${className}`}>
      <div className="">{children}</div>
    </Component>
  );
}
